import styled from "styled-components";
import { responsive } from "theme/responsive";

export const Card = styled.div`
   display: inline-block;
   background: ${({ theme }) => theme.colors?.white};
   padding: 2em;
   box-shadow: 2.81512e-15px 45.9743px 91.9487px rgba(51, 51, 51, 0.1525),
      inset -7.19418e-16px -11.749px 11.749px #f2f2f2, inset 7.19418e-16px 11.749px 11.749px #ffffff;
   border-radius: 24px;

   ${responsive("$medium")`
   svg {
       display: none;
   }
   `}
`;

export const CardsWrapper = styled.div<{ col: number; gap: number }>`
   display: grid;
   grid-template-columns: ${({ col }) => `repeat(${col}, 1fr)`};
   gap: ${({ gap }) => gap}em;

   ${responsive("$small")`
   grid-template-columns: repeat(1, 1fr);
   `}
`;

export const Block = styled.div`
   height: 15vh;

   ${responsive("$medium")`
     display: none;
`}
`;
